import { render, staticRenderFns } from "./DeleteAdminOrder.vue?vue&type=template&id=0db3a414&scoped=true&"
import script from "./DeleteAdminOrder.vue?vue&type=script&lang=js&"
export * from "./DeleteAdminOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3a414",
  null
  
)

export default component.exports